export default "__VITE_ASSET__eaa39053__"